<template>
    <site-img
        v-if="list && list.length > 0"
        class="md-featured-area grid-standard"
        type="bgImg"
        :src="bgType == 'img' ? suitableImg : ''"
        :style="{ 'background-color': bgType == 'color' ? bgColor : null }"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div v-if="title" class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
            <div class="style-container">
                <a
                    class="city-style"
                    :href="item.url"
                    v-for="(item, index) in list"
                    :key="index"
                    @mouseenter="mouseEnter($event, item)"
                    @mouseleave="mouseLeave($event)"
                    rel="noopener noreferrer"
                >
                    <site-img
                        type="bg-img"
                        class="bg-img"
                        :src="item.backPic || defaultImgs[index % 6]"
                        dir="width"
                    >
                        <div
                            class="style-title"
                            :class="{
                                tag: item.tagList && item.tagList.length > 0
                            }"
                            :style="{ bottom: bottom }"
                        >
                            {{ $ft.first(item.name) }}
                        </div>
                        <div class="mask">
                            <div class="pc-content">
                                <p>
                                    {{
                                        item.tagList && item.tagList.join(' | ')
                                    }}
                                </p>
                            </div>
                        </div>
                    </site-img>
                </a>
            </div>
        </module-box>
    </site-img>
</template>
<script>
import Common from '../index.js';
export default {
    mixins: [Common],
    data: function() {
        return {
            bottom: ''
        };
    },
    methods: {
        mouseEnter($event, item) {
            if (item.tagList && item.tagList.length > 0) {
                let tagEl = $event.target.querySelector('.pc-content p');
                if (tagEl) {
                    $event.target.querySelector('.style-title').style.bottom =
                        tagEl.offsetHeight + 20 + 10 + 'px';
                }
            }
        },
        mouseLeave($event) {
            $event.target.querySelector('.style-title').style.bottom = '';
        }
    }
};
</script>
<style lang="scss">
@import './style.scss';
</style>
